<template>
  <div class="card-content">
    <!-- <searchBox :dialogVisible.sync="moreSearchItem" @dialogCancle="dialogCancle" title="更多筛选">
      <div class="search-drawer">
        <el-form :model="form" label-position="top" ref="form">
          <el-form-item label="关键字搜索：">
            <el-input clearable placeholder="请输入违规事项名称" v-model="form.keywords"></el-input>
          </el-form-item>
        </el-form>
        <div class="search-drawer__footer">
          <el-button @click="searchBtn" size="small" type="primary">搜索</el-button>
          <el-button @click="refresh" plain size="small">刷新</el-button>
        </div>
      </div>
    </searchBox> -->
    <div class="search-content">
      <div class="mainBtn">
        <el-button
          @click="addNew()"
          size="small"
          type="primary"
          v-if="hasBtnPermission('main_credit_exposal_add')"
        >新增</el-button>
        <el-button
          @click="deleteSelectItem()"
          size="small"
          v-if="hasBtnPermission('main_credit_exposal_delete')"
        >删除</el-button>
      </div>
      <!-- <div class="searchBtn">
        <span class="label-form">关键字搜索：</span>
        <el-input
          @keyup.enter.native="searchBtn"
          clearable
          placeholder="请输入奖励名称/实施认定部门/相关文件文号/企业名称"
          style="width: 500px"
          v-model="form.keywords"
        ></el-input>
        <el-button @click="searchBtn" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
        <el-button
          @click="moreSearchItem = true"
          icon="el-icon-arrow-down"
          size="mini"
          type="text"
        >更多搜索</el-button>
        <el-divider direction="vertical"></el-divider>
        <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
      </div> -->
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="this.$globalGrayTableHeaderStyle"
      :height="tableMaxHeight"
      @filter-change="filterChange"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
      border
      class="table-content"
      ref="multipleTable"
      stripe
      v-loading="dataListLoading"
      @select-all="selectAll"
      row-key="id"
      :key="tableKey"
    >
      <el-table-column
        align="left"
        fixed
        type="selection"
        :selectable="checkSelectable"
        :reserve-selection="true"
        v-if="hasBtnPermission('main_credit_exposal_delete')"
      ></el-table-column>
      <el-table-column
        :index="indexMethod"
        :show-overflow-tooltip="true"
        align="center"
        fixed
        label="序号"
        type="index"
        width="50"
      ></el-table-column>
      <el-table-column
        :filters="statusFilters"
        align="center"
        fixed
        label="状态"
        prop="statusName"
        width="100"
      >
        <template slot-scope="scope">
          <i :class="formatterStatusClass(scope.row.status)"></i>
          <span>{{ scope.row.statusName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :filters="subjectTypeFilters"
        :show-overflow-tooltip="true"
        align="center"
        fixed
        header-align="center"
        label="主体类型"
        prop="subjectTypeName"
        width="100"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        fixed
        label="主体名称"
        prop="subjectLinkName"
        width="200"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        label="奖励名称"
        prop="name"
        width="200"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        label="相关文件文号"
        prop="fileName"
        width="200"
      >
        <template scope="scope">
          <span>{{ scope.row.fileName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        label="实施/认定部门"
        prop="deptName"
        width="200"
      >
        <template scope="scope">
          <span>{{ scope.row.deptName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        :filters="rewardTypeFilters"
        label="奖励类型"
        prop="typeName"
        width="150"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        label="奖励决定日期"
        sortable
        prop="startDate"
        width="140"
      >
        <template scope="scope">
          <span>{{ scope.row.startDate ? formatDate(scope.row.startDate, "yyyy-MM-dd") : '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        label="奖励结束日期"
        sortable
        prop="endDate"
        width="140"
      >
        <template scope="scope">
          <span>{{ scope.row.endDate ? formatDate(scope.row.endDate, "yyyy-MM-dd") : '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        label="奖励内容"
        prop="content"
        width="240"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        label="奖励事由"
        prop="reason"
        width="240"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        :filters="scopeTypeFilters"
        :filter-method="filterPublic"
        label="公开范围"
        prop="scopeTypeName"
        width="240"
      ></el-table-column>

      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        label="登记部门"
        prop="owerDeptName"
        width="240"
      ></el-table-column>
      <el-table-column
        :filters="[{ text: '是', value: 'status_3' }, { text: '否', value: 'subjectType_1,2' }]"
        :show-overflow-tooltip="true"
        align="center"
        header-align="center"
        label="是否撤销"
        min-width="100"
        prop="flowName"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.status == '3' ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        label="修改人"
        prop="updateUser"
        width="140"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        label="修改时间"
        sortable
        prop="updateTime"
        width="160"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        label="创建人"
        prop="createUser"
        width="140"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        label="创建时间"
        sortable
        prop="createTime"
        width="160"
      ></el-table-column>
      <el-table-column align="left" header-align="center" fixed="right" label="操作" width="160">
        <template scope="scope">
          <!-- <el-button type="text" v-if="scope.row.status != 1 || scope.row.canModify"
          @click="routerDetail(scope.row, (scope.row.status == 1 ? 'edit' : 'view'))">查看</el-button>-->
          <el-button
            @click="routerDetail(scope.row, (scope.row.canModify && scope.row.status == 1 ? 'edit' : 'view'))"
            type="text"
            v-if="hasBtnPermission('main_credit_exposal_view')"
          >查看</el-button>
          <el-button
            @click="routerDetail(scope.row, 'copy')"
            type="text"
            v-if="hasBtnPermission('main_credit_exposal_copy')"
          >复制</el-button>
          <el-divider
            direction="vertical"
            v-if="(scope.row.canModify && scope.row.status != 3 && (hasBtnPermission('main_credit_exposal_commit') || hasBtnPermission('main_credit_exposal_delete') || hasBtnPermission('main_credit_exposal_add') || hasBtnPermission('main_credit_exposal_revoke')))"
          ></el-divider>
          <el-popover placement="right" popper-class="btnPopver" width="200px" trigger="click">
            <div class="btnBox">
              <el-button
                @click="commitData(scope.row)"
                type="text"
                v-if="scope.row.status == 1 && hasBtnPermission('main_credit_exposal_commit')"
              >提交</el-button>
              <el-button
                @click="routerDetail(scope.row, 'edit')"
                type="text"
                v-if="(scope.row.status == 2) && hasBtnPermission('main_credit_exposal_add')"
              >修改</el-button>
              <el-button
                @click="deleteById(scope.row)"
                type="text"
                v-if="scope.row.status == 1 && hasBtnPermission('main_credit_exposal_delete')"
              >删除</el-button>
              <el-button
                @click="showRevokeForm(scope.row)"
                type="text"
                v-if="scope.row.status == 2 && hasBtnPermission('main_credit_exposal_revoke')"
              >撤销</el-button>
            </div>
            <el-button
              slot="reference"
              type="text"
              v-if="(scope.row.canModify && scope.row.status != 3 && (hasBtnPermission('main_credit_exposal_commit') || hasBtnPermission('main_credit_exposal_delete') || hasBtnPermission('main_credit_exposal_add') || hasBtnPermission('main_credit_exposal_revoke')))"
            >
              更多
              <i class="el-icon-arrow-down"></i>
            </el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="pageIndex"
      :page-size="pageSize"
      :page-sizes="[pageSize, 20, 50, 100]"
      :total="total"
      @current-change="currentChangeHandle"
      @size-change="sizeChangeHandle"
      background
      layout="total, sizes, prev, pager, next"
    ></el-pagination>

    <revokeDia :type="'1'" @revokeSuccess="getDataList" ref="revokeDiaRef"></revokeDia>
  </div>
</template>

<script>
import {
  getReWardListData,
  deleteRewardData,
  commitRewardData
} from "@/server/mainCredit.js";
import revokeDia from "../../components/revokeDia/index";
import { mapState } from "vuex";

export default {
  components: {
    revokeDia
  },
  data() {
    return {
      tableKey:Math.random(),
        // 363= 从上到下， 60+46+padding15px+100+16+30+64+32分页组件
      tableMaxHeight: document.documentElement.clientHeight - 363,
      dataListLoading: false,
      businessTypeNamelist: [],
      witnessStatuslist: [],
      visible: false,
      form: {
        keywords: "",
        flowName: ""
      },
      statusFilters: [],
      subjectTypeFilters: [],
      rewardTypeFilters: [],
      scopeTypeFilters: [],
      filters: {},
      sortParams: {
        order: "",
        prop: ""
      },
      moreSearchItem: false,
      pageSize: 10, //每页条数
      pageIndex: 1, //当前页
      total: 0, //总条数
      tableData: [],
      multipleSelection: []
    };
  },
  activated() {
    // this.refresh();
  },
  computed: {
    ...mapState({
      mainTypeList: state => state.dataDictionary.mainTypeList,
      publicScopeList: state => state.dataDictionary.publicScopeList
    })
  },
  watch: {
    mainTypeList: {
      immediate: true,
      deep: true, // 深度监听
      handler(val, newVal) {
        this.$nextTick(() => {
          let filters = [];
          this.mainTypeList.forEach(item => {
            filters.push({
              text: item.name,
              value: "subjectType_" + item.value
            });
          });
          this.subjectTypeFilters = filters;
        });
      }
    },
    publicScopeList: {
      immediate: true,
      deep: true, // 深度监听
      handler(val, newVal) {
        this.$nextTick(() => {
          let filters = [];
          this.publicScopeList.forEach(item => {
            filters.push({
              text: item.name,
              value: "scopeType_" + item.value
            });
          });
          this.scopeTypeFilters = filters;
        });
      }
    }
  },
  created() {
    this.$store.dispatch("dataDictionary/getMainTypeList"); //获取主体类型
    this.$store.dispatch("dataDictionary/getMainRevokeAttList"); // 获取撤销附件配置项数据
    this.$store.dispatch("dataDictionary/getPublicScopeList"); // 获取公开范围
    this.getDic("jg_subject_reward_type"); // 获取奖励类型
    this.getStatusList();
  },
  mounted() {
    const that = this;
    let resizeTag = true;
    window.onresize = () => {
      if (resizeTag) {
        //防抖动
        that.ifmove();
        resizeTag = false;
        setTimeout(() => {
          resizeTag = true;
        }, 1000);
      }
    };
    that.ifmove();
    this.getDataList();
  },
  methods: {
    selectAll(selection) {
      if (selection.length==0) {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 判断表格行是否可选
    checkSelectable(row, index) {
      /**
       * row：当前行数据
       * index：当前第几位
       */
      let flag = true;
      if (
        row.status == 1 &&
        row.canModify &&
        this.hasBtnPermission("main_credit_punish_delete")
      ) {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    },
    filterPublic(value, row) {
      let flag;
      if (value == "subjectType_2") {
        flag = "政务公开";
      } else {
        flag = "社会公开";
      }
      return row.scopeTypeName == flag;
    },
    computeBtnLenth(item) {
      if (this.hasBtnPermission("main_credit_exposal_commit")) {
        item.btnLength = 1;
      } else if (this.hasBtnPermission("main_credit_exposal_add")) {
        item.btnLength = 1;
      } else if (this.hasBtnPermission("main_credit_exposal_delete")) {
        item.btnLength = 1;
      } else if (this.hasBtnPermission("main_credit_exposal_revoke")) {
        item.btnLength = 1;
      } else {
        item.btnLength = 0;
      }

      return item.btnLength;
    },
    dialogCancle() {
      this.moreSearchItem = false;
    },

    getStatusList() {
      this.$httpReq.get("/complaint/listEnum/StatusEnum").then(res => {
        if (res.data.code === "1") {
          // { text: '待提交', value: 'status_1' },{ text: '资审澄清与修改文件', value: 'dataType_4' }
          let filters = [];
          res.data.data.forEach(item => {
            filters.push({
              text: item.name,
              value: "status_" + item.code
            });
          });
          this.statusFilters = filters;
        }
      });
    },

    ifmove() {
        // 363= 从上到下， 60+46+padding15px+100+16+30+64+32分页组件
      let tableMaxHeight = document.documentElement.clientHeight - 363;
      this.pageSize = parseInt(tableMaxHeight / 57) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight;
      });
      // this.getDataList()
    },

    formatterStatusClass(historyId) {
      switch (historyId) {
        case 2:
          return "icon-point icon-point-success";
          break;
        case 1:
          return "icon-point icon-point-verificationing";
          break;
        case 3:
          return "icon-point icon-point-info";
          break;
        default:
          return "";
          break;
      }
    },
    showRevokeForm(data) {
      this.$refs.revokeDiaRef.initDialog(data);
    },

    getDic(type) {
      // 获取字典

      this.$httpReq.get("/sys/dictData/getList?type=" + type).then(res => {
        if (res.data.code === "1") {
          let filters = [];
          res.data.data.forEach(item => {
            filters.push({
              text: item.name,
            //   value: "subjectType_" + item.value
            value: "typeName_" + item.value
            });
          });
          this.rewardTypeFilters = filters;
        }
      });
    },

    addNew() {
      removeTabHandle("rewardInfoForm");
      this.$router.push({
        name: "rewardInfoForm",
        query: {
          id: ""
        }
      });
    },

    getDataList(parentSearchKey) {
        this.tableData=[];
      // 获取列表数据
      this.dataListLoading = true;
      getReWardListData({
        page: this.pageIndex,
        rows: this.pageSize,
        // searchKey: this.form.keywords,
        searchKey: parentSearchKey||'',
        orderBy:
          this.sortParams.prop && this.sortParams.order
            ? this.sortParams.prop +
              (this.sortParams.order == "ascending" ? " asc" : " desc")
            : "",
        filter: this.filters
      }).then(res => {
        this.tableKey=Math.random();
        this.tableData = res.data.rows;
        this.tableData.forEach(item => {
          // 提交注释
          //  item.canModify = true;
          item.btnLength = this.computeBtnLenth(item);
        });
        this.total = res.data.total;
        this.$refs.multipleTable.doLayout();
        this.dataListLoading = false;
      });
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },

    filterChange(filters) {
    //   console.log(filters,"filters");

      let filtersParams = {};
      for (var i in filters) {
        var filtersArr = filters[i];
        let key = "",
          value = [];
        filtersArr.length > 0 &&
          filtersArr.forEach(item => {
            key = item.split("_")[0];
            value.push(item.split("_")[1]);
          });
        key && value.length > 0
          ? (filtersParams[key] = value.toString())
          : null;
      }
      if(filtersParams.status){
        filtersParams.statusList=filtersParams.status.split(",")
        delete filtersParams.status
      }
      if(filtersParams.subjectType){
        filtersParams.subjectTypeList=filtersParams.subjectType.split(",")
        delete filtersParams.subjectType
      }
      if(filtersParams.typeName){
        filtersParams.typeList=filtersParams.typeName.split(",")
        delete filtersParams.typeName
      }
      this.filters = filtersParams;
      this.getDataList();
    },
    sortChange(column, prop, order) {
      this.sortParams.prop = prop || column.prop;
      this.sortParams.order = order || column.order;
      this.getDataList();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    //搜索按钮
    searchBtn() {
      this.pageIndex = 1;
      this.moreSearchItem = false;
      this.getDataList();
    },

    refresh() {
      //刷新按钮
      this.pageIndex = 1;
      this.moreSearchItem = false;
      this.form.keywords = "";
      this.form.datasetCode = "-1";
      this.form.witnessStatus = "-1";
      this.getDataList();
    },

    routerDetail(item, flag) {
      // 跳转详情

      if (flag == "view") {
        removeTabHandle("rewardInfoView");
        this.$router.push({
          name: "rewardInfoView",
          query: {
            id: item.id
          }
        });
      }

      if (flag == "edit" || flag == "copy") {
        removeTabHandle("rewardInfoForm");
        this.$router.push({
          name: "rewardInfoForm",
          query: {
            id: item.id,
            copy: flag == "copy" ? true : false
          }
        });
      }
    },

    commitData(item) {
      this.$confirm(`确认提交吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        commitRewardData({
          id: item.id
        }).then(res => {
          if (res.data.code == "1") {
            this.$message({
              type: "success",
              message: "提交成功！"
            });
            this.getDataList();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        });
      });
    },

    deleteById(item) {
      this.$confirm(
        `<div style="text-align:center;font-size:16px">确认删除吗?<p style="font-size:12px">删除后的数据不可恢复</p></div>`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        deleteRewardData({
          id: item.id
        }).then(res => {
          if (res.data.code == "1") {
            this.$message({
              type: "success",
              message: "数据删除成功！"
            });
            this.getDataList();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        });
      });
    },

    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.id);
      });

      if (ids != "" || ids.length > 0) {
        this.$confirm(
          `<div style="text-align:center;font-size:16px">确认删除吗?<p style="font-size:12px">删除后的数据不可恢复</p></div>`,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          deleteRewardData({
            idList: ids
          }).then(res => {
            if (res.data.code == "1") {
              this.$message({
                type: "success",
                message: "数据删除成功！"
              });
              this.getDataList();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg
              });
            }
          });
        });
      } else {
        this.$message({
          type: "error",
          message: "未选择删除项。"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.btnBox {
  display: flex;
  flex-direction: column;

  .el-button {
    margin-left: 0px;
    margin-top: 10px;
  }
}

.card-content {
    margin-top: 16px;
  .card-content-search {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 4px;
    margin-right: 0px;

    /deep/ .el-input-group__append {
      padding: 0 10px;
      background: #1890ff;
      border-radius: 0px 2px 2px 0px;
      color: #ffffff;
    }

    .el-input {
      width: 270px;
      height: 30px;
      line-height: 30px;
      background: #ffffff;
      border-radius: 2px;
      outline: none;
    }

    /deep/ .el-input__inner {
      height: 30px;
      line-height: 30px;
      margin-top: 1px;
    }
  }
}
</style>